import apiClient from "../config/apiClient";

/**
 * Reorder a combined cancelled catering order (paid)
 * Used when a customer wants to reorder a previously cancelled combined order
 * Supports both upgrade (additional payment) and downgrade (refund) scenarios
 * 
 * @param {number|string} combineOrderId - The combine order ID to reorder
 * @param {object} payload - The reorder payload
 * @returns {Promise} Response from the API
 */
export const reorderCombinedCateringPaidCancelOrder = async (combineOrderId, payload) => {
  try {
    console.log('🔄 Calling reorder combined catering paid cancel order API:', {
      combineOrderId,
      payload
    });
    
    const response = await apiClient.post(
      `/agent/catering-service/paid-cancel-combine-re-order/${combineOrderId}`,
      payload
    );
    
    console.log('✅ Reorder combined catering paid cancel order response:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ Error reordering combined catering paid cancel order:', error);
    throw error;
  }
};

